"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackModalShow = void 0;
var _analytics = require("@cian/analytics");
const trackModalShow = _ref => {
  let {
    details,
    mainPromoId,
    isDiscountPromo,
    isBankMortgagePromo
  } = _ref;
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'show_sopr',
    label: 'different_prices',
    useLastProducts: true,
    page: {
      extra: {
        type: details.map(detail => detail.type),
        promo: mainPromoId ? {
          promo_id: mainPromoId,
          is_price_with_discount: Boolean(isDiscountPromo),
          is_bank_mortgage: Boolean(isBankMortgagePromo)
        } : undefined
      }
    }
  });
};
exports.trackModalShow = trackModalShow;